import axios from 'axios';
import queryString from 'query-string';
import { appConfig } from '../../utils/consts.ts';

const publicAxiosService = axios.create({
  baseURL: appConfig.restAPI,
  paramsSerializer: (params) => queryString.stringify(params),
});

publicAxiosService.interceptors.request.use((config) => config);

publicAxiosService.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    throw error.response;
  }
);

type GetParamsWithDefOnesConfig = {
  withCurrencyId?: boolean | number;
};

// TODO2: check if that's really required. Probably could be removed
export const getParamsWithDefOnes = (
  extraParams?: Record<string, unknown>,
  data: GetParamsWithDefOnesConfig = {
    withCurrencyId: false,
  }
) => ({
  timestamp: Math.floor(new Date().getTime() / 1000),
  ...(data.withCurrencyId === true
    ? { withCurrencyId: 1 }
    : typeof data.withCurrencyId === 'number'
      ? { withCurrencyId: data.withCurrencyId }
      : {}),
  ...extraParams,
});

export default publicAxiosService;
